import React from "react";
import EnhancedContentSection from "./../../components/common/enhanced-content-section";

const Playground = () => {
  return <EnhancedContentSection></EnhancedContentSection>;
};

export default Playground;
